/**
 * Analytics helpers — Meta Pixel + TikTok Pixel
 *
 * Both pixel snippets are injected in `public/index.html` with placeholders.
 * They are *guarded*: if the placeholder hasn't been replaced with a real ID,
 * `fbq` / `ttq` are NOT initialized and the helpers below are no-ops.
 *
 * To enable tracking later:
 *   1. Open `public/index.html`
 *   2. Replace `__META_PIXEL_ID__` with the real Meta Pixel ID
 *   3. Replace `__TIKTOK_PIXEL_ID__` with the real TikTok Pixel ID
 *   4. Redeploy.
 */

const isPlaceholder = (val) =>
  !val || /^__.*__$/.test(String(val)) || String(val).trim() === "";

export const trackEvent = (eventName, params = {}) => {
  if (typeof window === "undefined") return;
  try {
    // Meta — only fires if fbq has been initialized with a real ID
    if (typeof window.fbq === "function" && !isPlaceholder(window.__META_PIXEL_ID__)) {
      window.fbq("track", eventName, params);
    }
    // TikTok — only fires if ttq has been initialized with a real ID
    if (window.ttq && typeof window.ttq.track === "function" && !isPlaceholder(window.__TIKTOK_PIXEL_ID__)) {
      window.ttq.track(eventName, params);
    }
  } catch (e) {
    // never break the UI for analytics
  }
};

export const trackPageView = () => trackEvent("PageView");
export const trackViewContent = (params) => trackEvent("ViewContent", params);
export const trackInitiateCheckout = (params) => trackEvent("InitiateCheckout", params);
export const trackLead = (params) => trackEvent("Lead", params);
